import { useContext } from "react";
import { clientBulkSelectionContext } from "./clientBulkSelectionContext";

export function useClientBulkSelection() {
    const ctx = useContext(clientBulkSelectionContext);

    if (!ctx) {
        throw new Error(
            "useClientBulkSelection must be used within a ClientBulkSelectionContextProvider",
        );
    }

    return ctx;
}
